import { forwardRef, type Ref, type SVGProps } from "react";
const IconEHOOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.47 11.12-13-7a1 1 0 0 0-.94 0l-13 7a1 1 0 1 0 .94 1.76L5 12.06V26a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V12.06l1.53.82a1 1 0 1 0 .94-1.76M25 11v15H7V11l9-4.84z" />
    <path d="M22 16a1 1 0 0 1-1 1H11a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1H11a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconEHOOutlineSVG);
ForwardRef.displayName = "IconEHOOutline";
export { ForwardRef as IconEHOOutline };
